const MakePayment = () => {
    return ( 
        <div className="flex lg:flex-row lg:justify-between w-full bg-white">
            
        </div>
     );
}
 
export default MakePayment;